<template>

  <div ref="page-container" class="page-container">

    <div class="p-4" style="background-color: white;">
      
      <div class="ml-tabs" v-if="show_tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">

            <AdvancedSearchFilters
              class="mt-4 mb-4"
              source="MEMBER"
              @on_search_result="on_search_result"
              @on_search_count_result="on_search_count_result"
            />

            <AdvancedSearchTable
              :show_options_row="show_options_row"
              :count="count"
              :members="members"
              :search_options="search_options"
              @per_page_changed="per_page_changed"
              @order_by_changed="order_by_changed"
            />
          </div>
          <div v-show="active_tab === 1">

            <AdvancedSearchUserEditor
              :show_save_search="true"
              :search_options="search_options"
              ref="advanced-search-user-editor"
              source="USER"
              @on_search_result="on_search_result_users"
              @on_search_count_result="on_search_count_result_users"
            />

            <AdvancedSearchUserTable
              :count="count"
              :items="users"
              :search_options="search_options"
              @per_page_changed="per_page_changed"
            />
          </div>
          <div v-show="active_tab === 2">
            <AudienceTable 
              @created="audience_created"
            />
          </div>
        </div>
      </div>

      <div v-else>
        <AdvancedSearchFilters
          :show_refresh_button="!show_continue_button"
          class="mt-4 mb-4"
          source="MEMBER"
          @on_search_result="on_search_result"
          @on_search_count_result="on_search_count_result"
        />

        <div v-if="show_continue_button" class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">
          <memlist-button @click="continue_clicked" variant="primary">{{ $t('COMMON.CONTINUE') }}</memlist-button>
        </div>

        <AdvancedSearchTable
          :show_options_row="show_options_row"
          :count="count"
          :members="members"
          :search_options="search_options"
          @per_page_changed="per_page_changed"
          @order_by_changed="order_by_changed"
        />
      </div>

    </div>

  </div>

</template>


<script>
import axios from 'axios';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

import { is_mobile } from '@/core/services/utils';

import AdvancedSearchMemberEditor from '@/view/pages/ml/advanced_search/AdvancedSearchMemberEditor.vue';
import AdvancedSearchUserEditor from '@/view/pages/ml/advanced_search/AdvancedSearchUserEditor.vue';
import AdvancedSearchTable from '@/view/pages/ml/advanced_search/AdvancedSearchTable.vue';
import AdvancedSearchUserTable from '@/view/pages/ml/advanced_search/AdvancedSearchUserTable.vue';
import AudienceTable from '@/view/pages/ml/advanced_search/AudienceTable.vue';
import AdvancedSearchFilters from '@/view/pages/ml/advanced_search/AdvancedSearchFilters.vue';


export default {
  name: 'AdvancedSearchViewMUCF',
  components: {
    AdvancedSearchMemberEditor,
    AdvancedSearchUserEditor,
    AdvancedSearchTable,
    AdvancedSearchUserTable,
    AudienceTable,
    AdvancedSearchFilters,
  },
  emits: ['on_continue_clicked', 'on_search_count_result', 'on_search_result'],
  props: ['show_tabs','show_continue_button','show_refresh_button','show_options_row'],
  computed: {
    tabs() {
      let base = [
        { label: 'ADVANCED_SEARCH.MEMBERS', disabled: false },
        { label: 'ADVANCED_SEARCH.USERS', disabled: false },
        { label: 'ADVANCED_SEARCH.AUDIENCES', disabled: false },
        
      ];
      
      return base;
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'currentUserId', 'companies', 'periods', 'profile', 'settings','isTHS', 'sid']),

    is_mobile() {
      return is_mobile();
    },

  },
  mixins: [ toasts ],
  watch: {

  },
  mounted() {

  },
  methods: {
    continue_clicked() {
      this.$emit('on_continue_clicked');
    },
    audience_created(item) {
      this.$refs['advanced-search-member-editor'].add_audience(item);
    },
    order_by_changed(order_by) {
      this.search_options.order_by = order_by;
      this.$refs['advanced-search-member-editor'].run_search();
    },

    per_page_changed(per_page, page) {
      this.$refs['advanced-search-member-editor'].change_per_page(per_page, page);
    },

    on_search_result(result, search_options) {
      this.search_options = search_options;
      this.members = result;

      this.$emit('on_search_result', this.search_options);
    },
    on_search_count_result(count) {
      this.count = count;
      this.$emit('on_search_count_result', this.count);
    },
    on_search_result_users(result, search_options) {
      this.search_options = search_options;
      this.users = result;
    },
    on_search_count_result_users(count) {
      this.count = count;
    }
  },
  data() {
    return {
      active_tab: 0,
      search_options: null,
      members: [],
      users: [],
      count: 0,
      columns: []
    }
  },
}

</script>

<style lang="css" scoped>


.page-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}

.fill-rest {
  flex: 1 1 auto;
}


.quick-search-card {
  overflow: scroll;
}

.selected-item-active {
  border-radius: 4px;
  background: #f4fcff;
  color: black;
}

.card-title {
  background-color:#f7f7f7;
  border-bottom:1px solid #dedede;
  padding-bottom: 15px;

}

.card-title-p {
  margin-bottom: 8px !important;
  margin-top: 7px !important;
}


.top-container {
  display: flex;
}

.content {
  flex-grow: 1;
  margin-top: 0px !important;
  padding-top: 0px !important;
  margin-left: 8px !important;
}



.drawer-header {
  margin-bottom: -13px !important;
}

.drawer {
  border-right: 1px solid #dddddd !important;
}

.fixed-font {
  font-size: 0.95rem !important;
  font-weight: 500;
  line-height: 1rem;
}

:deep .v-application--wrap {
  min-height: 0px !important;
}

</style>
